import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const styles = {
  dashboardColumn:
    (alignment: string, growing: boolean, rigid: boolean) =>
    (): SystemStyleObject<Theme> => ({
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 1,
      alignItems: alignment === 'left' ? 'flex-start' : alignment,
      textAlign: alignment,
      flexGrow: growing ? 1 : 0,
      flexShrink: rigid ? 0 : 1,
    }),

  dashboardColumnLeft: {
    alignItems: 'flex-start',
    textAlign: 'left',
  },

  dashboardColumnCenter: {
    alignItems: 'center',
    textAlign: 'center',
  },

  dashboardColumnGrowing: {
    flexGrow: 1,
  },

  dashboardColumnRigid: {
    flexShrink: 0,
  },

  dashboardColumnHeader: (theme: Theme) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'inherit',
    textAlign: 'inherit',
    padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
    boxSizing: 'border-box',
    height: 82,
    justifyContent: 'flex-end',
    fontWeight: 'bold',
  }),

  dashboardColumnCell: (theme: Theme) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'inherit',
    textAlign: 'inherit',
    padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
    boxSizing: 'border-box',
    height: 48,
    position: 'relative',
    justifyContent: 'center',
  }),

  dashboardColumnCellTiny: {
    fontSize: 12,
    paddingTop: 0,
    paddingBottom: 0,
    lineHeight: 12,
    overflow: 'hidden',
    maxHeight: '100%',
  },
};
